export class DuplexChannelEventArgs {

    constructor(public readonly channelId: string, public readonly responseReceiverId: string) {
    }
}